<template>
    <div>
        {{ clients }}
    </div>
</template>


<script>
export default {
    name: "InactiveClients",
    data: function () {
        return {
            clients: [],
            totalRecords: 0
        }
    },
    methods: {
        async getInactive(params) {
            try {
                const response = this.$api.clients.getInactiveClients(params);
                this.clients = response.data.clients;
                this.totalRecords = response.data.total_records;
            } catch (err) {
                console.error(err);
            }
        }
    },
    async mounted () {
        await this.getInactive({
            page: 1,
            limit: 10
        })
    }
}
</script>